import Axios from '../../library/Axios'

export const DonationPostAction = (project_id: string, user_id: string, amount: string, full_name: string, mobile: string, pay_do: string, doc_name: string, doc_memorial: string, doc_template_id: string, gift_name: string, gift_mobile: string, comment: string, anonymous: boolean, anonymous_price: boolean, anonymous_profile: boolean, seedling_type?: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'DONATION_POST_REQUEST' })

        let params: any = {
            project_id: project_id,
            user_id: user_id,
            amount: amount,
            full_name: full_name,
            mobile: mobile,
            gift_name: gift_name,
            gift_mobile: gift_mobile,
            doc_name: doc_name,
            doc_memorial: doc_memorial,
            doc_template_id: doc_template_id,
            comment: comment,
            anonymous: anonymous,
            anonymous_price: anonymous_price,
            anonymous_profile: anonymous_profile,
            pay_do: pay_do,
        }

        if (seedling_type != "") {
            params["seedling_type"] = seedling_type;
        }

        const { data } = await new Axios().post(`/post/submit/donation`, params);

        dispatch({ type: 'DONATION_POST_SUCCESS', payload: data });
    } catch (error) {
        dispatch({ type: 'DONATION_POST_ERROR' });
    } finally {
        dispatch({ type: 'DONATION_POST_RESET' });
    }
}